import React, { Fragment } from 'react'

import { useMediaQuery } from 'react-responsive'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { useCancelAction, useUserSubscriptions } from '../../hooks'
import useDowngradeModal from '../DowngradeModal'
import { API__USER } from '../../../../api'
import { USER__SET_SUBSCRIPTION, USER__SET_SUBSCRIPTIONS } from '../../../../store/actions'
import { PRODUCT_LIST, EDUCATION_GROUP_ID } from '../../../../common/constants/ProductConstants'
import { DowngradeTo } from './DowngradeTo'
import { SubscriptionItem } from './SubscriptionItem'

export const SubscriptionBanner = ({ products }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 1199px)' })
    const { user_details: userDetails, user_subscription: userSubscription } = useSelector(state => state)
    const { t } = useTranslation()
    const subscriptions = useUserSubscriptions()
    const dispatch = useDispatch()
    const cancel = useCancelAction()
    const { modal, setOpen, setDowngradeAction, setDowngradeTo } = useDowngradeModal()

    const preparedSubscriptions = subscriptions
        ? subscriptions.filter(
              subscription =>
                  subscription.expirationDate > Date.now() && subscription.product.productCode !== PRODUCT_LIST.Free,
          )
        : null

    const currentProduct = userSubscription.product.productCode

    const cancelSubscription = () => {
        const isEducation =
            userDetails &&
            userDetails.roleInProjectDto &&
            userDetails.roleInProjectDto.userGroupInProjectDto.customId === EDUCATION_GROUP_ID

        setDowngradeTo(isEducation ? products.month[0].name : '')
        setDowngradeAction(() => cancel)
        setOpen(true)
    }

    const undoDowngrade = async () => {
        if (userSubscription.productForDowngrade === null && userSubscription.recurringEnabled === false) {
            await API__USER.UPDATE_CURRENT_SUBSCRIPTION(userSubscription.id, {
                ...userSubscription,
                recurringEnabled: true,
            })
        } else {
            await API__USER.CANCEL_DOWNGRADE(userSubscription.id)
        }

        dispatch(USER__SET_SUBSCRIPTION(await API__USER.GET_SELECTED_SUBSCRIPTION(userDetails.id)))
        dispatch(USER__SET_SUBSCRIPTIONS(await API__USER.GET_SUBSCRIPTIONS(userDetails.id)))
    }

    if (preparedSubscriptions.length === 0 || [PRODUCT_LIST.Free, PRODUCT_LIST.TrialEnded].includes(currentProduct)) {
        return (
            <div className="subscriptions__state subscriptions__state-free">
                <h2>
                    {t(
                        'Sorry, the trial period is over. Take a look at the packages to find out how you can keep creating engaging content!',
                    )}
                </h2>
            </div>
        )
    }

    return (
        <>
            {preparedSubscriptions ? (
                <>
                    {modal}
                    <div className="subscriptions__state">
                        {preparedSubscriptions
                            .filter(subscription => subscription.productForDowngrade)
                            .map((subscription, i) => {
                                return (
                                    <Fragment key={i}>
                                        <DowngradeTo subscription={subscription} />
                                    </Fragment>
                                )
                            })}
                        {preparedSubscriptions.map(subscription => {
                            return (
                                <SubscriptionItem
                                    key={subscription.id}
                                    subscription={subscription}
                                    cancelSubscription={cancelSubscription}
                                    undoDowngrade={undoDowngrade}
                                    isMobile={isMobile}
                                />
                            )
                        })}
                    </div>
                </>
            ) : null}
        </>
    )
}
